import { render, staticRenderFns } from "./table-proposal-eligible-national-ambit.vue?vue&type=template&id=045c88d5&scoped=true&"
import script from "./table-proposal-eligible-national-ambit.vue?vue&type=script&lang=js&"
export * from "./table-proposal-eligible-national-ambit.vue?vue&type=script&lang=js&"
import style0 from "./table-proposal-eligible-national-ambit.vue?vue&type=style&index=0&id=045c88d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c88d5",
  null
  
)

export default component.exports